import { dotToCommaTransform } from "@/lib/formatters/NumericTextFieldInputCleaner";
import { Box, Indent, Row, Txt } from "@stenajs-webui/core";
import { cssColor } from "@stenajs-webui/theme";
import { VehicleTypeIcon } from "@/components/vehicle-type-icon/VehicleTypeIcon";
import {
  MAX_LENGTH,
  MAX_WEIGHT,
  MIN_LENGTH,
  MIN_WEIGHT,
} from "../../add-vehicle-type/models/AddVehicleTypeFormModel";
import { BulkEditRatePrice } from "../types";
import { vehicleTypeAll } from "./constants";
import { Tooltip } from "@stenajs-webui/tooltip";

export const formatVehicleLength = (
  lengthFrom: number | null,
  lengthTo: number | null
) => {
  if (
    (lengthFrom == null || lengthFrom === MIN_LENGTH) &&
    (lengthTo == null || lengthTo >= MAX_LENGTH)
  ) {
    return "Any";
  }
  return `${dotToCommaTransform(String(lengthFrom))} to ${dotToCommaTransform(
    String(lengthTo)
  )}`;
};

export const formatWeightFromTo = (
  weightFrom: number | null,
  weightTo: number | null
) => {
  if (
    (weightFrom == null || weightFrom === MIN_WEIGHT) &&
    (weightTo == null || weightTo >= MAX_WEIGHT)
  ) {
    return "Any";
  }
  return `${dotToCommaTransform(String(weightFrom))} to ${dotToCommaTransform(
    String(weightTo)
  )}`;
};

export const vehicleTypeCell = (
  item: BulkEditRatePrice,
  setRoutePriceId: (routePriceId: string) => void,
  open: () => void
) => {
  return (
    <Row alignItems={"center"} indent>
      <Box justifyContent={"flex-start"} justifyItems={"center"} width={"32px"}>
        <Tooltip
          label={item.vehicleType?.shortDescription ?? "All vehicle types"}
        >
          <VehicleTypeIcon vehicleTypeCode={item.vehicleType?.id} />
        </Tooltip>
      </Box>
      <Indent />
      <Indent>
        <Txt
          onClick={() => {
            setRoutePriceId(item.id);
            open();
          }}
          style={{ cursor: "pointer" }}
          color={cssColor("--lhds-color-blue-600")}
        >
          {item.vehicleType === null ? vehicleTypeAll : item.vehicleType?.code}
        </Txt>
      </Indent>
    </Row>
  );
};
